<script setup>
import { useAttrs } from 'vue';
import pggLogo from 'dashboard/assets/images/pgg-logo.webp';

const attrs = useAttrs();
</script>

<template>
  <img
    v-bind="attrs"
    :src="pggLogo"
    alt="PGG"
    class="object-contain rounded-md"
  />
</template>
